import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { CalendarEvent } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { getDisplayName } from '@frontend/get-display-name';
import { InsuranceDetailsConstants, InsuranceTabUtilsTypes } from '@frontend/insurance-tab';

export const getUniqueInsuranceStatuses = () => {
  const uniqueStatuses = new Map<string, InsuranceTabUtilsTypes.StatusInfo>();
  for (const value of InsuranceDetailsConstants.SCHEDULE_FILTER_INSURANCE_STATUS_MAPPING.values()) {
    const key = value.text.toLowerCase();
    if (!uniqueStatuses.has(key)) {
      uniqueStatuses.set(key, { ...value, text: key });
    }
  }
  return uniqueStatuses;
};

type GetPersonDetailsByAppointmentReturnType = {
  personId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  appointmentType: string;
  practitionerName: string;
  appointmentLocationId: string;
};

export const getCalendarEventDetails = (calendarEvent: CalendarEvent) => {
  const { attendeeId: personId = '', attendeeDetails, details, locationId: appointmentLocationId } = calendarEvent;
  const firstName = attendeeDetails?.firstName || '';
  const lastName = attendeeDetails?.lastName || '';
  const preferredName = attendeeDetails?.preferredName || '';

  const { fullName } = getDisplayName({ firstName, lastName, preferredName });

  const practitionerName = details?.orNa || '';
  const appointmentType = details?.rTyNa || '';

  return {
    personId,
    firstName,
    lastName,
    fullName,
    appointmentType,
    practitionerName,
    appointmentLocationId: appointmentLocationId || '',
  };
};

export const getAppointmentDetails = (appointment: Appointment) => {
  const { person, practitionerName, type, locationId } = appointment;
  const personId = person?.personId || '';
  const firstName = person?.firstName || '';
  const lastName = person?.lastName || '';
  const preferredName = person?.preferredName || '';
  const { fullName } = getDisplayName({ firstName, lastName, preferredName });
  return {
    personId,
    firstName,
    lastName,
    fullName,
    practitionerName: practitionerName || '',
    appointmentType: type || '',
    appointmentLocationId: locationId || '',
  };
};

export const getPersonDetailsByAppointment = (
  appt: Appointment | CalendarEvent,
  isScheduleV3FlagEnabled: boolean
): GetPersonDetailsByAppointmentReturnType => {
  if (isScheduleV3FlagEnabled) {
    return getCalendarEventDetails(appt as CalendarEvent);
  } else {
    return getAppointmentDetails(appt as Appointment);
  }
};
